export const formatPersonLabel = (person) => {
  if (!person) return "--";
  if (typeof person === "string") return person;
  if (person.name?.trim()) return person.name.trim();
  const parts = [person.firstName, person.middleName, person.lastName].filter(
    Boolean
  );
  if (parts.length) return parts.join(" ").trim();
  return person.email || "--";
};
